import React, { useEffect, useState, useMemo } from "react";
import { Helmet } from "react-helmet";
import { Row, Col, Form } from "reactstrap";
// import { default as ReactSelect, components } from "react-select";
import Select, { components } from "react-select";
import Animated from "react-select/animated";

import viewIcon from "../../assets/images/app/common/listing-view-image.svg";
import editIcon from "../../assets/images/app/common/listing-edit-image.svg";
import deleteIcon from "../../assets/images/app/common/listing-delete-image.svg";
import checkCircleIcon from "../../assets/images/app/common/listing-check-circle-img.svg";
import emailIcon from "../../assets/images/app/common/listing-email-img.svg";

import { SearchBox } from "../../components/SearchBox";
import { Pagination } from "../../components/Pagination";
import { DataTable } from "../../components/DataTable";
import { PageTitles, PDFStatus } from "../../constants";
import { SummaryCard } from "../../components/SummaryCard";
import DateRangePicker from "./DateRangePicker";
import AutoComplete from "../../components/AutoComplete/AutoComplete";
import { customStyles } from "./CustomStyles";
import { filterOptions } from "./Config";
import { data, DUMMY_EMAILS } from "./DummyData";
import { ConfirmationModal, CustomModal, InformationModal } from "../../components/CustomModal";
import { CustomButton } from "../../components/CustomButton";
import QuillEditorWithHTML from "./PdfEditor";
import { STATUS } from "../../constants/PDFStatus";

const COLUMNS = {
    PDF_TITLE: "PDF Title",
    CREATED_DATE: "Created Date",
    PREVIEW: "Preview",
    STATUS: "Status",
    ACTIONS: "Actions"
};

const Option = (props) => {
    const { data, isSelected, innerRef, innerProps } = props;
    return (
        <div>
            <components.Option {...props}>
                <div
                    ref={innerRef}
                    {...innerProps}
                    className={`checkbox-item ${isSelected ? "checked" : ""}`}
                >
                    <div className="checkbox"></div>
                    <span>{data.label}</span>
                </div>
            </components.Option>
        </div>
    );
};

const PDFListing = () => {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [selectedOption, setSelectedOption] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
    const [selectedEmails, setSelectedEmails] = useState({ optionSelected: null });

    const [editModal, setEditModal] = useState(false);

    const [confirmationModalConfig, setConfirmationModalConfig] = useState({
        isOpen: false,
        imageSrc: null,
        modalTitle: "",
        modalSubText: "",
        yesButtonText: "Yes",
        noButtonText: "Cancel"
    });

    const [state, setState] = useState({ optionSelected: null });

    const handleChange = (selected) => {
        setState({
            optionSelected: selected
        });
    };

    const handleStatusChange = (selected) => {
        setSelectedOption(selected);
    };

    const toggleEmailModal = () => {
        setState({
            optionSelected: null
        });
        setIsEmailModalOpen(!isEmailModalOpen);
        setSelectedEmails([]);
    };

    const handleSendEmail = () => {
        // Implement email sending logic here
        console.log(
            "Sending email to:",
            selectedEmails.map((email) => email.value)
        );
        setState({
            optionSelected: null
        });
        toggleEmailModal();
    };

    const handleChangeStart = (date) => {
        setStartDate(date);
    };

    const handleChangeEnd = (date) => {
        setEndDate(date);
    };

    const handleView = (pdfUrl) => {
        // setPdfFile(pdfUrl);

        setIsModalOpen(true);
    };

    const handleModalToggling = () => {
        setIsModalOpen(!isModalOpen);
    };

    const handleEditModalToggling = () => {
        setEditModal(!editModal);
    };

    const openConfirmationModal = (config) => {
        setConfirmationModalConfig({
            ...confirmationModalConfig,
            ...config,
            isOpen: true
        });
    };

    const handleEditClick = () => {
        // setShowModal(true);
        setEditModal(true);
    };

    const handleDeleteClick = () => {
        openConfirmationModal({
            imageSrc: deleteIcon,
            modalTitle: "Are you sure you want to delete this PDF?",
            modalSubText: "",
            yesButtonText: "Delete"
        });
    };

    const handleCheckClick = () => {
        openConfirmationModal({
            imageSrc: checkCircleIcon,
            modalTitle: "Are you sure you want to approve this pdf?",
            modalSubText: "",
            yesButtonText: "Approve"
        });
    };

    const handleModalClose = () => {
        setConfirmationModalConfig({ ...confirmationModalConfig, isOpen: false });
    };

    return (
        <div>
            <Helmet>
                <title>{PageTitles.PDF_LISTING}</title>
            </Helmet>

            <SummaryCard colClassName={"mt-2"}>
                <Row className="p-2 mt-2 ">
                    <Col sm="12" md="3" lg="3">
                        <SearchBox className="me-3 w-100 my-1" value={""} onChange={() => {}} />
                    </Col>
                    <Col sm="12" md="2" lg="2"></Col>

                    <Col sm="12" md="7" lg="7" align="right">
                        <div className="d-flex justify-content-end align-items-center ">
                            <AutoComplete
                                isClearable
                                customStyles={customStyles.statusFilter}
                                options={filterOptions}
                                onChange={handleStatusChange}
                                value={selectedOption}
                                placeholder="Status"
                                theme={(theme) => ({
                                    ...theme,
                                    colors: {
                                        ...theme.colors,
                                        primary: "#2795ae"
                                    }
                                })}
                                maxMenuHeight={220}
                                classNamePrefix="status-header-search-admin"
                            />
                            <DateRangePicker
                                startDate={startDate}
                                endDate={endDate}
                                handleChangeStart={handleChangeStart}
                                handleChangeEnd={handleChangeEnd}
                                icon="bx bx-calendar"
                                iconClass="icon-class"
                            />
                        </div>
                    </Col>
                </Row>

                <DataTable
                    isHeightRequired={true}
                    tableContainerClass="mt-2"
                    loading={false}
                    data={data}
                    config={[
                        {
                            title: COLUMNS.PDF_TITLE,
                            headerClass: "column-header px-4",
                            className: "px-4",
                            render: (data) => <div>{data.PDFTitle}</div>
                        },
                        {
                            title: COLUMNS.CREATED_DATE,
                            headerClass: "column-header",
                            render: (data) => <div>{data.CreatedDate}</div>
                        },
                        {
                            title: COLUMNS.PREVIEW,
                            headerClass: "column-header",
                            render: (data) => (
                                <div role="button" onClick={() => handleView(data.pdfUrl)}>
                                    <img
                                        src={viewIcon}
                                        alt="View Icon"
                                        style={{ cursor: "pointer" }}
                                        height={"30px"}
                                        width={"30px"}
                                    />
                                    <span className="ml-2">{data.Preview}</span>
                                </div>
                            )
                        },
                        {
                            title: COLUMNS.STATUS,
                            headerClass: "column-header",
                            render: (data) => (
                                <div
                                    className={`job-status-common ${PDFStatus.getLabelClass(
                                        data.Status
                                    )}`}
                                >
                                    {PDFStatus.getDisplayTextKey(data.Status)}
                                </div>
                            )
                        },
                        {
                            title: COLUMNS.ACTIONS,
                            headerClass: "column-header",
                            render: (data) => (
                                <div className="d-flex align-items-center ">
                                    <img
                                        src={editIcon}
                                        alt="Edit Icon"
                                        style={{ cursor: "pointer", marginRight: "10px" }}
                                        height={"30px"}
                                        width={"30px"}
                                        onClick={handleEditClick}
                                    />
                                    <img
                                        src={deleteIcon}
                                        alt="Delete Icon"
                                        style={{ cursor: "pointer", marginRight: "20px" }}
                                        onClick={handleDeleteClick}
                                    />
                                    {data.Status !== STATUS.APPROVED && (
                                        <img
                                            src={checkCircleIcon}
                                            alt="History Icon"
                                            style={{ cursor: "pointer", marginRight: "20px" }}
                                            onClick={handleCheckClick}
                                        />
                                    )}

                                    <img
                                        src={emailIcon}
                                        alt="Email Icon"
                                        style={{ cursor: "pointer", marginRight: "20px" }}
                                        height={"15px"}
                                        onClick={toggleEmailModal}
                                    />
                                </div>
                            )
                        }
                    ]}
                />

                <Pagination
                    rowLimit={10}
                    onPageClick={() => {}}
                    currentPage={1}
                    totalData={50}
                    handleChange={(e) => {}}
                />
            </SummaryCard>

            {/* PDF Modal */}
            <CustomModal
                isOpen={isModalOpen}
                modalTitle="PDF Preview"
                handleModalToggling={handleModalToggling}
                size="lg"
                className="pdf-modal"
                bodyClassName="pdf-modal-body"
                customButton
            >
                <iframe
                    src={"/dummy1.pdf"}
                    style={{ width: "100%", height: "450px", border: "none" }}
                    frameborder="0"
                ></iframe>
            </CustomModal>

            {/* PDF EDIT Modal */}
            <CustomModal
                isOpen={editModal}
                modalTitle="PDF Editor"
                handleModalToggling={handleEditModalToggling}
                size="lg"
                className="pdf-modal"
                bodyClassName="pdf-modal-body"
                customButton
            >
                <QuillEditorWithHTML />
                <div className="d-flex justify-content-end ">
                    <CustomButton
                        title={"Save"}
                        color="primary"
                        className="saved-btn"
                        onClick={() => setEditModal(false)}
                        loading={false}
                    />
                </div>
            </CustomModal>

            {/* Confirmation Modal */}
            <ConfirmationModal
                size="md"
                hasCustomConfig
                isOpen={confirmationModalConfig.isOpen}
                customImageSrc={confirmationModalConfig.imageSrc}
                customTitle={confirmationModalConfig.modalTitle}
                customSubText={confirmationModalConfig?.modalSubText}
                customYesBtnText={confirmationModalConfig.yesButtonText}
                customNoBtnText={confirmationModalConfig.noButtonText}
                onNo={handleModalClose}
                onYes={() => {
                    // Implement the action to take on confirmation
                    handleModalClose();
                }}
            />

            <CustomModal isOpen={isEmailModalOpen} size="md" className="mb-4">
                <Form onSubmit={(e) => e.preventDefault()}>
                    <div className="d-flex flex-column align-items-center">
                        <img src={emailIcon} className="" height={"100px"} width={"100px"} />

                        <div className="mb-2">
                            <h4 className=" fw-bold  text-center custom-title my-2">
                                {"Send Via Email"}
                            </h4>

                            <h5 className=" custom-subText my-2">
                                Send the PDF{" "}
                                <strong style={{ color: "#CC9C58" }}>{"ABC.pdf"}</strong> to the
                                following email address
                            </h5>
                        </div>
                        <Row className="mb-2 w-100 d-flex justify-content-center my-4 ">
                            <Col md="10">
                                {/* <Select
                                    classNamePrefix="status-header-search-admin"
                                    placeholder="Enter Email Address"
                                    customStyles={customStyles.emailFilter}
                                    options={DUMMY_EMAILS}
                                    isMulti
                                    closeMenuOnSelect={false}
                                    hideSelectedOptions={false}
                                    components={{
                                        Option
                                    }}
                                    onChange={handleChange}
                                    value={state.optionSelected}
                                    theme={(theme) => ({
                                        ...theme,
                                        colors: {
                                            ...theme.colors,
                                            primary: "#fff"
                                        }
                                    })}
                                    className="mb-3"
                                    maxMenuHeight={120}
                                    isClearable
                                /> */}
                                <AutoComplete
                                    classNamePrefix="status-header-search-admin"
                                    placeholder="Enter Email Address"
                                    customStyles={customStyles.emailFilter}
                                    options={DUMMY_EMAILS}
                                    isMulti
                                    closeMenuOnSelect={false}
                                    hideSelectedOptions={false}
                                    components={{
                                        Option
                                    }}
                                    onChange={handleChange}
                                    value={state.optionSelected}
                                    theme={(theme) => ({
                                        ...theme,
                                        colors: {
                                            ...theme.colors,
                                            primary: "#fff"
                                        }
                                    })}
                                    className="mb-3"
                                    maxMenuHeight={120}
                                    isClearable
                                />
                            </Col>
                        </Row>
                        <div className="d-flex justify-content-evenly btns-main-con mb-4 mt-4">
                            <CustomButton
                                title={"Cancel"}
                                className="me-3 custom-btn-sm cancel-btn-text-color"
                                color="primary"
                                outline
                                onClick={toggleEmailModal}
                                loading={false}
                                disabled={false}
                            />
                            <CustomButton
                                title={"Send Email"}
                                color="primary"
                                className="custom-btn-sm shadow-theme grad-primary btn-text-color"
                                onClick={handleSendEmail}
                                loading={false}
                            />
                        </div>
                    </div>
                </Form>
            </CustomModal>
            <InformationModal
                size="md"
                isOpen={showModal}
                Title={"Given Pdf will be Editable!"}
                confirmButtonText="Done"
                ImageSrc={editIcon}
                onConfirmClick={() => setShowModal(false)}
            />
        </div>
    );
};

export default PDFListing;
